import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { withBaseModel } from "../extensions/with-base-model"
import { Parameter } from "../../database"

const ChemicalParameterStoreProps = {
  ...BaseModelStoreProps,
  data: types.optional(types.array(types.frozen()),[]),
}

/**
 * Model description here for TypeScript hints.
 */
export const ChemicalParameterStoreModel = types
  .model("ChemicalParameterStore")
  .props(ChemicalParameterStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof ChemicalParameterStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init(){
      self.initModel();
    },
    async getChemicalParameter() {
      this.set('loading', true);
      Parameter.online = true
      const models = await Parameter.fetch({
        parameter_category_id__eq: 2, sort: 'number'
      }).catch((e) => {
        console.warn(e)
        this.set('error', e);
        return []
      }).then((models) => {        
        return models.map((model) => model.toArray())
      }).finally(() => {
        this.set('loading', false)
        Parameter.online = false
      })
      this.set("data", models)
      return models
    }
  }))

type ChemicalParameterStoreType = Instance<typeof ChemicalParameterStoreModel>
export interface ChemicalParameterStore extends ChemicalParameterStoreType {}
type ChemicalParameterStoreSnapshotType = SnapshotOut<typeof ChemicalParameterStoreModel>
export interface ChemicalParameterStoreSnapshot extends ChemicalParameterStoreSnapshotType {}
export const createChemicalParameterStoreDefaultModel = () => types.optional(ChemicalParameterStoreModel, {})
